import { render, staticRenderFns } from "./breeds-container.vue?vue&type=template&id=2915afad&scoped=true&lang=pug"
import script from "./breeds-container.js?vue&type=script&lang=js&external"
export * from "./breeds-container.js?vue&type=script&lang=js&external"
import style0 from "./breeds-container.vue?vue&type=style&index=0&id=2915afad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2915afad",
  null
  
)

export default component.exports